

  export default {
    layout: 'nothing',

    scrollToTop: true,
    head(){
        return {
            bodyAttrs: {
                class: this.dataLoaded ? '' : 'pb-0'
            }
      }
    },

  mounted() {
    document.addEventListener('DOMContentLoaded', function () {
        if(navigator.userAgent.toLowerCase().indexOf("android") > -1){
            window.location.href = 'https://play.google.com/store/apps/details?id=goa.tourism';
        }
        if(navigator.userAgent.toLowerCase().indexOf("iphone") > -1){
            window.location.href = 'https://apps.apple.com/in/app/goa-tourism-travel-guide/id6463205036';
        }
    });
  },


    data() {
      return {
        title: 'Goa Tourism App',
        dataLoaded: false
      }
    },
    head() {
      return {
        bodyAttrs: {
                class: this.dataLoaded ? '' : 'pb-0'
            },
        title: this.title + " | Download Goa App for Free",
        meta: [{
            hid: 'og:title',
            property: 'og:title',
            content: this.title + " | Download Goa App"
          },
          {
            hid: 'twitter:title',
            property: 'twitter:title',
            content: this.title + " | Download Goa App"
          }
        ]
      }
    },
    methods:{
      start() {
            this.loading = true
            this.dataLoaded = false;
        },
        finish() {
            this.loading = false;
            this.dataLoaded = true;
        }
    }

  }

